import dashboardTabModule from './dashboard/dashboard.js';
import botsTabModule from './bots/bots.js';
import devicesTabModule from './devices/devices.js';
import eventsTabModule from './events/events.js';
import infoTabModule from './info/info.js';
import rulesTabModule from './rules/rules.js';
import scenesTabModule from './scenes/scenes.js';
import servicesTabModule from './services/services.js';
import settingsTabModule from './settings/settings.js';
import statesTabModule from './states/states.js';
import subscriptionsTabModule from './subscriptions/subscriptions.js';
import editTaskTabModule from './editTask/editTask.js';
import usersTabModule from './users/users.js';
import prioritiesTabModule from './priorities/priorities.js';
import trendsHistoryTabModule from './trendsHistory/trendsHistory.js';
import relativesTabModule from './relatives/relatives.js';

export default angular
  .module('main.locations.edit.tabs', [
    dashboardTabModule,
    botsTabModule,
    devicesTabModule,
    eventsTabModule,
    infoTabModule,
    rulesTabModule,
    scenesTabModule,
    servicesTabModule,
    settingsTabModule,
    statesTabModule,
    subscriptionsTabModule,
    editTaskTabModule,
    usersTabModule,
    prioritiesTabModule,
    trendsHistoryTabModule,
    relativesTabModule,
  ])
  .name;
